module.exports = __webpack_public_path__ + "static/board-c0af9ae970c7e75a6de36dc20036f75f.png";